import React, {useState} from 'react'
import './projects.css'
import { projects } from '../../data/projects_data'
import LightBox from '../../Components/LightBox/LightBox.js'
import {motion} from 'framer-motion/dist/framer-motion'
import {options} from '../../Components/options'

function Projects() {
    let [current, setCurrent] = useState(1);
    let [CurrentDetails, setCurrentDetails] = useState(0);
    let [modal, setModal] = useState(false);
    
    function modalBox(e) {
        if(!modal) {
            setCurrentDetails(e.target.id)
            setModal(true)
        }
        else {
            setCurrentDetails(0)
            setModal(false)
        }
    }
    return (
        <motion.div className="projectsContainer"
        initial={options.initial}
        animate={options.animate}
        exit={options.exit}
        onAnimationComplete={() => { window.scrollTo(0,0)}}>
            <LightBox modal={modal} setModal={setModal} CurrentDetails={CurrentDetails} data={projects} />
            <div className="projectsWrapper">
                <ul>
                    {
                        projects.map((project, index) => (
                        <li>
                            <div className="magicalWall_wrap">
                                <img loading="lazy" src={project.src} />
                                <button className="btnGallery" 
                                    id={index} onClick={(e) => modalBox(e)}> 
                                     {project.Header}
                                </button>
                            </div>
                        </li>
                        ))
                    }
                </ul>
            </div>
        </motion.div>
    )
}

export default Projects
